import React from 'react';
import { CLIENT_VERSION } from '../../config';
import { isMobile } from '../../utils/screen';

const date = new Date();

const year = date.getFullYear();

const CBXFooter = ({ styles }) => (
	<div style={{
		fontSize: '11px', marginTop: isMobile ? '1.2em' : '0.2em', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '1em', ...styles
	}}>
		<div
			dangerouslySetInnerHTML={{ __html: `Copyright &copy ${year}` }}
		/>
		<span style={{ marginLeft: '0.2em', marginRight: '0.2em', color: 'black' }}>
			{`v${CLIENT_VERSION} - `}
			<a href="https://www.councilbox.com" rel="noreferrer noopener" style={{ color: 'black' }}>
				Councilbox Technology S.L.
			</a>
		</span>
	</div>
);

export default CBXFooter;
